<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Documento</th>
                                <th>Tamanho</th>
                                <th>Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(document, index) in documents" :key="document.id">
                                <td v-if="isImage(document.name)" class="td-name">
                                    <a :href="getUrlDownload(document.name)" :download="document.name.name">
                                        <img :src="getImg(document.name)" style="height: 35px;" />
                                        {{ document.name.name }}
                                    </a>
                                </td>
                                <td v-else-if="isPdf(document.name)" class="td-name">
                                    <a href="javascript:;" @click="getPdf(document.name)">
                                        {{ document.name.name }}
                                    </a>
                                </td>
                                <td v-else class="td-name">
                                    <a :href="getUrlDownload(document.name)" :download="document.name.name">
                                        {{ document.name.name }}
                                    </a>
                                </td>
                                <td>{{document.name.size | formatSize }}</td>
                                <td>{{document.name.contentType }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <b-modal v-model="modalShow" size="lg" id="showImages">
            <iframe :src="contentPdf" width="100%" height="400px" />
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['documents'],
    methods: {  
        getImg(_file) {
            return 'data: ' + _file.contentType + ';base64,' + _file.content;
        },
        getPdf(_file) {
            this.contentPdf = 'data:' + _file.contentType + ';base64,' + _file.content;
            this.modalShow = true;
        },
        getUrlDownload(_file) {
            return "data:" + _file.contentType + ";base64," + _file.content;
        },
        isImage(_file) {
            var contentTypesImages = ["image/png", "image/jpg", "image/jpeg", "image/gif"];

            if (contentTypesImages.indexOf(_file.contentType) != -1) {
                return true;
            }

            return false;
        },
        isPdf(_file) {
            var contentTypesPdf = ["application/pdf"];
            if (contentTypesPdf.indexOf(_file.contentType) != -1) {
                return true;
            }

            return false;
        }
    },
    data () {
        return {
            contentPdf: null,
            modalShow: false
        };
    },
    mounted () {
        var self = this;
        self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            self.contentPdf = null;
            self.modalShow = false;
        });
    }
}
</script>

<style scoped>
audio:not(.md-image), canvas:not(.md-image), embed:not(.md-image), iframe:not(.md-image), img:not(.md-image), object:not(.md-image), video:not(.md-image) {
    height: 400px;
}
</style>
